import { Device } from "@twilio/voice-sdk";

const PREFERRED_MICROPHONE_KEY = "PreferredMicrophoneId";

export const getMicrophones = async () => {
  try {
    await navigator.mediaDevices.getUserMedia({ audio: true });
    const devices = await navigator.mediaDevices.enumerateDevices();
    return devices.filter((device) => device.kind === "audioinput");
  } catch (err) {
    console.error("Error accessing microphones:", err);
  }
};

export async function selectMicrophone(device: Device, deviceId: string): Promise<void> {
  await device.audio?.setInputDevice(deviceId);
  localStorage.setItem(PREFERRED_MICROPHONE_KEY, deviceId);
}

export async function applyPreferredMicrophone(device: Device): Promise<void> {
  const preferredMicrophoneId = localStorage.getItem(PREFERRED_MICROPHONE_KEY);
  if (!preferredMicrophoneId || !device.audio || device.audio.inputDevice?.deviceId === preferredMicrophoneId) {
    return;
  }
  await device.audio.setInputDevice(preferredMicrophoneId).catch(() => undefined);
}
